import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { CampaignCodeGeneratorStructure } from '../api-client/api-types'
import {
  updateGeneratorMasterSettingsAsync,
  deleteGeneratorParameterAsync,
  updateCampaignCodeGeneratorOrderAsync,
} from '../store/actions'
import Heading from './heading'
import CampaignCodesAdministrationMasterAndSelector from './campaign-codes-administration-master-and-separator'
import Modal, { ModalHead, ModalBody } from './modal'
import styles from '../component-styles/campaign-codes-administration.module.scss'

interface Props {
  onHide: any
}

export default function EditCodeStructureModal({
  onHide,
}: Props): React.ReactElement | null {
  const { generatedStructure } = useSelector(
    (
      s: any,
    ): {
      generatedStructure: CampaignCodeGeneratorStructure
    } => s.campaignCodes,
  )

  const dispatch = useDispatch()
  const [form, setForm] = useState(generatedStructure)
  const [showSettings, setShowSettings] = useState(true)

  useEffect(() => {
    setForm(generatedStructure)
  }, [generatedStructure])

  const onRemove = (removeID: string): void => {
    // eslint-disable-next-line
    // debugger
    dispatch(deleteGeneratorParameterAsync({ removeID }))
    setForm({
      ...form,
      paramDefs: form.paramDefs.filter(
        (aParamDef): boolean => removeID !== aParamDef.fieldID,
      ),
    })
  }

  return (
    <Modal
      active={showSettings}
      toggleActive={() => {
        setShowSettings(!showSettings)
        onHide()
      }}
      type="column"
      superWide
      className={styles.closeModal}
    >
      <ModalHead style={{ right: 'auto' }}>
        <Heading type={3} align="left">
          Edit code structure
        </Heading>
      </ModalHead>
      <ModalBody>
        <CampaignCodesAdministrationMasterAndSelector
          onRemove={onRemove}
          validationChecks={form.validationChecks}
          masterPrefix={form.masterPrefix}
          paramSeparator={form.paramSeparator}
          form={form}
          onChangeOrder={(changes) => {
            const order = changes.paramDefs.map((item: any) => item.fieldID)
            dispatch(updateCampaignCodeGeneratorOrderAsync({ newOrder: order }))
            setForm({
              ...form,
              ...changes,
            })
          }}
          onChange={(changes): void => {
            const updatedForm = {
              ...form,
              ...changes,
            }
            const updateFormToSave = {
              masterPrefix: updatedForm.masterPrefix,
              paramSeparator: updatedForm.paramSeparator,
              validationChecks: [...updatedForm.validationChecks],
            }
            dispatch(updateGeneratorMasterSettingsAsync(updateFormToSave))
            setForm(updatedForm)
          }}
        />
      </ModalBody>
    </Modal>
  )
}
